const DOCUMENTATION_PATH = `${process.env.PUBLIC_URL}/Documentation`;
export const DOCUMENTATION_JSON_FILE = `${process.env.PUBLIC_URL}/documentation-tree`;
export const CLOUD_DOCUMENTATION_JSON_FILE = `/documentation-tree`;

export const DOCUMENTATION = {
  NOTICE_GSTA_DELTAOS: (codeNotice) => `${DOCUMENTATION_PATH}/GeneralDocumentation/Notices/Notices/notice_${codeNotice}`,

  PATCH_NOTE_GSTA_DELTAOS_JSON: (version) => `${DOCUMENTATION_PATH}/GeneralDocumentation/PatchNotes/patchNote${version.replace(/\./g, "_")}`,

  PATCH_NOTE_SIMULATION_JSON: (softwareCode, version) => `${DOCUMENTATION_PATH}/SimulationDocumentation/${softwareCode}/${softwareCode}/PatchNotes/patchNote_${softwareCode}_${version.replace(/\./g, "_")}`,
  
  UPDATE_NOTE_GSTA_DELTAOS: (updateNoteName) => `${DOCUMENTATION_PATH}/GeneralDocumentation/Notices/UpdatesNotes/${updateNoteName}`,

  UPDATE_NOTE_SIMULATION: (softwareCode, updateNoteName) => `${DOCUMENTATION_PATH}/SimulationDocumentation/${softwareCode}/${softwareCode}/UpdatesNotes/${updateNoteName}`,

  SIMULATION_CONTENT: (softwareCode, machineCode) => `${DOCUMENTATION_PATH}/SimulationDocumentation/${softwareCode}/${machineCode}/Documentation/simulationContent_${machineCode}`,

  TRAINING_CATALOG: (softwareCode, machineCode) => `${DOCUMENTATION_PATH}/SimulationDocumentation/${softwareCode}/${machineCode}/Documentation/trainingCatalog_${machineCode}`,

};

export const FOLDER_TRANSLATION_KEY = {
  NoticesGstaDeltaOs: "notices_gsta_deltaos",
  Notices: "notices",
  FirstStepGuides: "firstStepGuide",
  SimulatorDescription: "simulator_description",
  UpdatesNotes: "update_notes",
  Documentation: "documentation",
}